import React from 'react';
import { Route } from 'react-router-dom';
import { withStyles, Typography } from './../../../themes/default';

import { Container } from './../../includes/container';
import { Header, Sidebar } from './../../../pages/shared';
import { BreadcrumbItem } from './../../includes/breadcrumb';
import { SnackbarDefault } from './../../includes/snackbar';

const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1
  },
  container: {
    flex: 1,
    marginTop: theme.spacing.unit * 8
  }
});

const Layout = ({children, ...rest}) => {

  const { classes } = rest;

  return (
    <Typography component="div" className={ classes.root }>
      <Header/>
      <Sidebar/>
      <BreadcrumbItem to='/'>
        Dashboard
      </BreadcrumbItem>
      <Container className={ classes.container }>
        { children }
      </Container>
      <SnackbarDefault/>
    </Typography>
  )
}

const BackendLayout = ({ component: Component, ...rest }) => {
  return (
    <Route { ...rest } render={ matchProps => (
      <Layout classes={ rest.classes }>
          <Component { ...matchProps } />
      </Layout>
    )} />
  )
};

export default withStyles(styles)(BackendLayout);
